import { VImg } from 'vuetify/lib/components/VImg';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c(VImg,{staticStyle:{"border-radius":"10%"},attrs:{"size":"60","src":_vm.profilePic},on:{"click":function($event){return _vm.openImageDialog()}}}),_c('input',{ref:"fileInput",style:({ display: _vm.display }),attrs:{"type":"file","id":"files","accept":"image/*"},on:{"change":_vm.getSelectedImage}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }